module.exports = __webpack_public_path__ + "static/formularz-reklamacyjny-baranski-0b885d3bd84766e6593625ebf679d088.pdf";